import { AxiosError } from 'axios';
import { logger } from '@nx-frontend/shared/utils';

export function requestErrorLoggerResponseInterceptorOnRejected(error: AxiosError): Promise<AxiosError> {
  // Any status codes that falls outside the range of 2xx cause this function to trigger
  if (error.response) {
    // The request was made and the server responded with a status code
    // that falls out of the range of 2xx
    let logLevel: 'debug' | 'error' = 'debug';
    if (error.response.status >= 500 && error.response.status <= 599) {
      logLevel = 'error';
    }
    logger[logLevel](
      'Axios: request failed, URL: %s, message: %s, response: %j',
      error.response.config.url,
      error.message,
      error.response.data
    );
  } else if (error.request) {
    // The request was made but no response was received
    logger.warn('Axios: No response received: %s', error.request.url);
  } else {
    // Something happened in setting up the request that triggered an Error
    logger.warn('Axios: Error %s', error.message);
  }

  // Forward the error to be handled elsewhere
  return Promise.reject(error);
}
